import airplane from '../../img/template_thumnail/slide/airplane.png';
import airplane2x from '../../img/template_thumnail/slide/airplane@2x.png';
import album1 from '../../img/template_thumnail/slide/album_1.png';
import album12x from '../../img/template_thumnail/slide/album_1@2x.png';
import album2 from '../../img/template_thumnail/slide/album_2.png';
import album22x from '../../img/template_thumnail/slide/album_2@2x.png';
import animal from '../../img/template_thumnail/slide/animal.png';
import animal2x from '../../img/template_thumnail/slide/animal@2x.png';
import autumnbrown from '../../img/template_thumnail/slide/autumn_brown.png';
import autumnbrown2x from '../../img/template_thumnail/slide/autumn_brown@2x.png';
import blackwhite from '../../img/template_thumnail/slide/black_&_white.png';
import blackwhite2x from '../../img/template_thumnail/slide/black_&_white@2x.png';
import businessplan1 from '../../img/template_thumnail/slide/businessplan_1.png';
import businessplan12x from '../../img/template_thumnail/slide/businessplan_1@2x.png';
import businessplan2 from '../../img/template_thumnail/slide/businessplan_2.png';
import businessplan22x from '../../img/template_thumnail/slide/businessplan_2@2x.png';
import businessplan3 from '../../img/template_thumnail/slide/businessplan_3.png';
import businessplan32x from '../../img/template_thumnail/slide/businessplan_3@2x.png';
import chartstyle from '../../img/template_thumnail/slide/chart_style.png';
import chartstyle2x from '../../img/template_thumnail/slide/chart_style@2x.png';
import colorfulfigure from '../../img/template_thumnail/slide/colorful_figure.png';
import colorfulfigure2x from '../../img/template_thumnail/slide/colorful_figure@2x.png';
import darkalbum from '../../img/template_thumnail/slide/dark_album.png';
import darkalbum2x from '../../img/template_thumnail/slide/dark_album@2x.png';
import eggcase from '../../img/template_thumnail/slide/eggcase.png';
import eggcase2x from '../../img/template_thumnail/slide/eggcase@2x.png';
import filetemplate from '../../img/template_thumnail/slide/filetemplate.png';
import filetemplate2x from '../../img/template_thumnail/slide/filetemplate@2x.png';
import funbluereport from '../../img/template_thumnail/slide/fun_blue_report.png';
import funbluereport2x from '../../img/template_thumnail/slide/fun_blue_report@2x.png';
import gradationgreen from '../../img/template_thumnail/slide/gradationgreen.png';
import gradationgreen2x from '../../img/template_thumnail/slide/gradationgreen@2x.png';
import greybrowser from '../../img/template_thumnail/slide/grey_browser.png';
import greybrowser2x from '../../img/template_thumnail/slide/grey_browser@2x.png';
import interior from '../../img/template_thumnail/slide/interior.png';
import interior2x from '../../img/template_thumnail/slide/interior@2x.png';
import marketing from '../../img/template_thumnail/slide/marketing.png';
import marketing2x from '../../img/template_thumnail/slide/marketing@2x.png';
import navygold from '../../img/template_thumnail/slide/navi_gold.png';
import navygold2x from '../../img/template_thumnail/slide/navi_gold@2x.png';
import neptunesimple from '../../img/template_thumnail/slide/neptune_simple.png';
import neptunesimple2x from '../../img/template_thumnail/slide/neptune_simple@2x.png';
import pastelcircle from '../../img/template_thumnail/slide/pastel_circle.png';
import pastelcircle2x from '../../img/template_thumnail/slide/pastel_circle@2x.png';
import pinkrounded from '../../img/template_thumnail/slide/pinkrounded.png';
import pinkrounded2x from '../../img/template_thumnail/slide/pinkrounded@2x.png';
import pinktree from '../../img/template_thumnail/slide/pinktree.png';
import pinktree2x from '../../img/template_thumnail/slide/pinktree@2x.png';
import process from '../../img/template_thumnail/slide/process.png';
import process2x from '../../img/template_thumnail/slide/process@2x.png';
import proposal from '../../img/template_thumnail/slide/proposal.png';
import proposal2x from '../../img/template_thumnail/slide/proposal@2x.png';
import purplechart from '../../img/template_thumnail/slide/purplechart.png';
import purplechart2x from '../../img/template_thumnail/slide/purplechart@2x.png';
import recipe from '../../img/template_thumnail/slide/recipe.png';
import recipe2x from '../../img/template_thumnail/slide/recipe@2x.png';
import rectanglethings from '../../img/template_thumnail/slide/rectangle_things.png';
import rectanglethings2x from '../../img/template_thumnail/slide/rectangle_things@2x.png';
import researchpaper from '../../img/template_thumnail/slide/research_paper.png';
import researchpaper2x from '../../img/template_thumnail/slide/research_paper@2x.png';
import travelguide from '../../img/template_thumnail/slide/travelguide.png';
import travelguide2x from '../../img/template_thumnail/slide/travelguide@2x.png';
import tvnews from '../../img/template_thumnail/slide/tvnews.png';
import tvnews2x from '../../img/template_thumnail/slide/tvnews@2x.png';
import watercolor from '../../img/template_thumnail/slide/watercolor.png';
import watercolor2x from '../../img/template_thumnail/slide/watercolor@2x.png';
import wood from '../../img/template_thumnail/slide/wood.png';
import wood2x from '../../img/template_thumnail/slide/wood@2x.png';

export const SlideTemplate = {
  templatePath: '/template/slide/',
  width: '132px',
  height: '74px',
  items: [
    {
      thumnailImage: airplane,
      thumnailImage2x: airplane2x,
      titlei18nID: 'SlideTemplateItems.airplane',
      fileName: 'airplane.pptx'
    },
    {
      thumnailImage: album1,
      thumnailImage2x: album12x,
      titlei18nID: 'SlideTemplateItems.Album1',
      fileName: 'Album 1.pptx'
    },
    {
      thumnailImage: album2,
      thumnailImage2x: album22x,
      titlei18nID: 'SlideTemplateItems.Album2',
      fileName: 'Album 2.pptx'
    },
    {
      thumnailImage: animal,
      thumnailImage2x: animal2x,
      titlei18nID: 'SlideTemplateItems.Animal',
      fileName: 'Animal.pptx'
    },
    {
      thumnailImage: autumnbrown,
      thumnailImage2x: autumnbrown2x,
      titlei18nID: 'SlideTemplateItems.autumnBrown',
      fileName: 'autumn brown.pptx'
    },
    {
      thumnailImage: blackwhite,
      thumnailImage2x: blackwhite2x,
      titlei18nID: 'SlideTemplateItems.blackWhite',
      fileName: 'black&white.pptx'
    },
    {
      thumnailImage: businessplan1,
      thumnailImage2x: businessplan12x,
      titlei18nID: 'SlideTemplateItems.BusinessPlan1',
      fileName: 'Business Plan 1.pptx'
    },
    {
      thumnailImage: businessplan2,
      thumnailImage2x: businessplan22x,
      titlei18nID: 'SlideTemplateItems.BusinessPlan2',
      fileName: 'Business Plan 2.pptx'
    },
    {
      thumnailImage: businessplan3,
      thumnailImage2x: businessplan32x,
      titlei18nID: 'SlideTemplateItems.BusinessPlan3',
      fileName: 'Business Plan 3.pptx'
    },
    {
      thumnailImage: chartstyle,
      thumnailImage2x: chartstyle2x,
      titlei18nID: 'SlideTemplateItems.ChartStyle',
      fileName: 'Chart style.pptx'
    },
    {
      thumnailImage: colorfulfigure,
      thumnailImage2x: colorfulfigure2x,
      titlei18nID: 'SlideTemplateItems.colorfulFigure',
      fileName: 'colorful figure.pptx'
    },
    {
      thumnailImage: darkalbum,
      thumnailImage2x: darkalbum2x,
      titlei18nID: 'SlideTemplateItems.darkAlbum',
      fileName: 'dark album.pptx'
    },
    {
      thumnailImage: eggcase,
      thumnailImage2x: eggcase2x,
      titlei18nID: 'SlideTemplateItems.eggCase',
      fileName: 'egg case.pptx'
    },
    {
      thumnailImage: filetemplate,
      thumnailImage2x: filetemplate2x,
      titlei18nID: 'SlideTemplateItems.fileTemplate',
      fileName: 'file template.pptx'
    },
    {
      thumnailImage: funbluereport,
      thumnailImage2x: funbluereport2x,
      titlei18nID: 'SlideTemplateItems.funBlueReport',
      fileName: 'fun blue report.pptx'
    },
    {
      thumnailImage: gradationgreen,
      thumnailImage2x: gradationgreen2x,
      titlei18nID: 'SlideTemplateItems.gradationGreen',
      fileName: 'gradation green.pptx'
    },
    {
      thumnailImage: greybrowser,
      thumnailImage2x: greybrowser2x,
      titlei18nID: 'SlideTemplateItems.greyBrowser',
      fileName: 'grey browser.pptx'
    },
    {
      thumnailImage: interior,
      thumnailImage2x: interior2x,
      titlei18nID: 'SlideTemplateItems.Interior',
      fileName: 'Interior.pptx'
    },
    {
      thumnailImage: marketing,
      thumnailImage2x: marketing2x,
      titlei18nID: 'SlideTemplateItems.Marketing',
      fileName: 'Marketing.pptx'
    },
    {
      thumnailImage: navygold,
      thumnailImage2x: navygold2x,
      titlei18nID: 'SlideTemplateItems.navyGold',
      fileName: 'navy&gold.pptx'
    },
    {
      thumnailImage: neptunesimple,
      thumnailImage2x: neptunesimple2x,
      titlei18nID: 'SlideTemplateItems.neptuneSimple',
      fileName: 'neptune simple.pptx'
    },
    {
      thumnailImage: pastelcircle,
      thumnailImage2x: pastelcircle2x,
      titlei18nID: 'SlideTemplateItems.pastelCircle',
      fileName: 'pastel circle.pptx'
    },
    {
      thumnailImage: pinkrounded,
      thumnailImage2x: pinkrounded2x,
      titlei18nID: 'SlideTemplateItems.pinkRounded',
      fileName: 'pink rounded.pptx'
    },
    {
      thumnailImage: pinktree,
      thumnailImage2x: pinktree2x,
      titlei18nID: 'SlideTemplateItems.pinkTree',
      fileName: 'pink tree.pptx'
    },
    {
      thumnailImage: process,
      thumnailImage2x: process2x,
      titlei18nID: 'SlideTemplateItems.Process',
      fileName: 'Process.pptx'
    },
    {
      thumnailImage: proposal,
      thumnailImage2x: proposal2x,
      titlei18nID: 'SlideTemplateItems.Proposal',
      fileName: 'Proposal.pptx'
    },
    {
      thumnailImage: purplechart,
      thumnailImage2x: purplechart2x,
      titlei18nID: 'SlideTemplateItems.purpleChart',
      fileName: 'purple chart.pptx'
    },
    {
      thumnailImage: recipe,
      thumnailImage2x: recipe2x,
      titlei18nID: 'SlideTemplateItems.Recipe',
      fileName: 'Recipe.pptx'
    },
    {
      thumnailImage: rectanglethings,
      thumnailImage2x: rectanglethings2x,
      titlei18nID: 'SlideTemplateItems.rectangleThings',
      fileName: 'rectangle things.pptx'
    },
    {
      thumnailImage: researchpaper,
      thumnailImage2x: researchpaper2x,
      titlei18nID: 'SlideTemplateItems.ResearchPaper',
      fileName: 'Research paper.pptx'
    },
    {
      thumnailImage: travelguide,
      thumnailImage2x: travelguide2x,
      titlei18nID: 'SlideTemplateItems.TravelGuide',
      fileName: 'Travel Guide.pptx'
    },
    {
      thumnailImage: tvnews,
      thumnailImage2x: tvnews2x,
      titlei18nID: 'SlideTemplateItems.tvNews',
      fileName: 'tv news.pptx'
    },
    {
      thumnailImage: watercolor,
      thumnailImage2x: watercolor2x,
      titlei18nID: 'SlideTemplateItems.watercolor',
      fileName: 'watercolor.pptx'
    },
    {
      thumnailImage: wood,
      thumnailImage2x: wood2x,
      titlei18nID: 'SlideTemplateItems.Wood',
      fileName: 'Wood.pptx'
    }
  ]
};
